const hasMonitoradosNaLista = () => document.querySelectorAll('[data-tour="lista-monitorados-tabela"] tbody tr').length > 0

const buildListaMonitoradosTourSteps = (tourManager) => {
    const steps = [
        {
            popover: {
                title: 'Lista de Monitorados',
                description: 'Aqui ficam os monitorados cadastrados. É nesta tela que você acompanha as leituras e a situação de cada ponto monitorado.',
            },
        },
        {
            element: '[data-tour="lista-monitorados-tabela"]',
            popover: {
                title: 'Seus monitorados',
                description: 'A tabela mostra nome, cliente, tipo e a última comunicação de cada monitorado.',
                side: 'top',
                align: 'start',
            },
        },
    ]

    if (hasMonitoradosNaLista()) {
        steps.push({
            element: () =>
                document.querySelector('[data-tour="lista-monitorados-nome"]') ||
                document.querySelector('[data-tour="lista-monitorados-tabela"] tbody tr td a'),
            popover: {
                title: 'Abrir status',
                description: 'Clique no <strong>nome</strong> do monitorado para abrir a tela de Status. Lá você vê gráficos e os dados de leitura dos parâmetros do equipamento vinculado a esse monitorado.',
                side: 'bottom',
                align: 'start',
            },
            onHighlighted: (element) => {
                const link = element?.closest?.('a') || element?.querySelector?.('a') || element

                if (!link || link._hdvTourStatusClick) return

                const onClick = () => tourManager.minimize()

                link.addEventListener('click', onClick)
                link._hdvTourStatusClick = onClick
            },
            onDeselected: (element) => {
                const link = element?.closest?.('a') || element?.querySelector?.('a') || element

                if (link?._hdvTourStatusClick) {
                    link.removeEventListener('click', link._hdvTourStatusClick)
                    delete link._hdvTourStatusClick
                }
            },
        })
    } else {
        steps.push({
            popover: {
                title: 'Nenhum monitorado',
                description: 'Quando houver monitorados cadastrados, eles aparecem nesta lista. Clique no nome de um deles para abrir a tela de Status, com gráficos e leituras dos parâmetros vinculados.',
            },
        })
    }

    steps.push({
        popover: {
            title: 'Tudo pronto!',
            description: 'Use esta lista para acompanhar as comunicações. Sempre que quiser ver gráficos e leituras, abra o Status pelo nome do monitorado.',
        },
    })

    return steps
}

export default buildListaMonitoradosTourSteps
